import Error from '../model/Error';
import Utilization from '../dto/Utilization';
import axios from 'axios';

export default class UtilizationRepository {
    static generate(kindergarten, type, startDate, endDate) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/statistics/${kindergarten}/group-statistics/${type}/${startDate}/${endDate}`)
                .then(response => resolve(Utilization.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
